/* eslint-disable react-hooks/exhaustive-deps */

import * as yup from "yup";

import {
  AUMENTO_DE_PLANTA,
  ERROR_MESSAGE,
  NUEVO_CARGO,
  REQUIRED_MESSAGE,
} from "../../constants";
import {
  Backdrop,
  CircularProgress,
  FormControl,
  FormHelperText,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@material-ui/core";
import {
  BorderGreenButton,
  BorderRedButton,
  ColorButton,
} from "../../utils/form/buttonsForm";
import { Controller, useForm } from "react-hook-form";
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers";
import React, { useEffect, useState } from "react";
import { amountValues, defaultValues } from "./models";
import {
  finishRequisition,
  getRequisitionById,
  saveRequisition,
} from "../../actions/requisition-actions";

import DateFnsUtils from "@date-io/date-fns";
import ModalConfirmBase from "../../utils/form/modalConfirmBase";
import Title from "../../utils/form/title";
import TitleCase from "react-title-case";
import Utils from "../../utils/utils";
import deLocale from "date-fns/locale/es";
import { getActiveProcess } from "../../actions/process-actions";
import { getActiveRegionals } from "../../actions/regional-actions";
import { getChargesByStatusActive } from "../../actions/charge-actions";
import { getContractTypeForGenerate } from "../../actions/generation-contarct-action";
import { getMaestras } from "../../actions/maestras-actions";
import moment from "moment";
import { styles } from "./styles";
import { useQuery } from "react-query";
import { useStateValue } from "../../context/store";
import { withRouter } from "react-router-dom";
import { yupResolver } from "@hookform/resolvers/yup";

const RequisitionForm = (props) => {
  const _ = require("lodash");
  const [{}, dispatch] = useStateValue();
  const { id } = props.match.params;
  const isAddMode = !id;
  const classes = styles();
  const [charges, setCharges] = useState([]);
  const [process, setProcess] = useState([]);
  const [regionales, setRegionales] = useState([]);
  const [maestras, setMaestras] = useState({
    rolDecargo: [],
    motivoRetiro: [],
    motivoSolicitud: [],
    tipoContrato: [],
  });
  const [requisition, setRequisition] = useState([]);
  const [isDisabled, setIsDisabled] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [cantidadIsDisabled, setCantidadIsDisabled] = useState(true);
  const [showAmountMessage, setShowAmountMessage] = useState(false);
  const [open, setOpen] = useState(false);
  const [confirm, setConfirm] = useState({
    open: false,
    question: "",
    oneButtons: false,
    handleClickOut: () => {},
    handleClick: () => {},
    type: "",
    title: "",
  });

  const ordenarMaestras = (maestras) => {
    maestras.motivoRetiro = _.sortBy(maestras.motivoRetiro, (o) => o);
    maestras.motivoSolicitud = _.sortBy(maestras.motivoSolicitud, (o) => o);
    return maestras;
  };

  const getListaMaestras = async () => {
    const response = await getMaestras();
    let orderMaestras = ordenarMaestras(
      response.data && response.data.maestras
    );
    setMaestras(orderMaestras);
    return orderMaestras;
  };

  const getListContractTypes = async () => {
    const resp = await getContractTypeForGenerate();
    let orderContractTypes = _.sortBy(
      resp && resp.data,
      (o) => o.contractTypeDescription
    );
    return orderContractTypes;
  };

  const { data, status: statusListContractType } = useQuery(
    "listContractType",
    getListContractTypes
  );

  useEffect(() => {
    getListaMaestras();
    const getAllCharges = async () => {
      const response = await getChargesByStatusActive();
      let orderCharges = _.sortBy(
        response.data && response.data.chargeList,
        (o) => o.denomination
      );
      setCharges(orderCharges);
    };
    getAllCharges();

    const title = isAddMode ? "Crear nueva requisición" : "Editar requisición";
    dispatch({
      type: "SET_BREADCRUMB",
      breadCrumbText: title,
      breadCrumbSubText: title,
      index: 0,
    });
  }, []);

  useEffect(() => {
    const getRegionales = async () => {
      const response = await getActiveRegionals();
      let orderRegionales = _.sortBy(
        response.data && response.data.regionalList,
        (o) => o.name
      );
      setRegionales(orderRegionales);
    };
    getRegionales();
  }, []);

  useEffect(() => {
    const getAllProcess = async () => {
      const response = await getActiveProcess();
      let orderProcess = _.sortBy(
        response.data && response.data.processList,
        (o) => o.description
      );
      setProcess(orderProcess);
    };
    getAllProcess();
  }, []);

  const schema = yup.object().shape({
    regionalId: yup.string().nullable().required(REQUIRED_MESSAGE),
    requestDate: yup.date().nullable().required(REQUIRED_MESSAGE),
    processId: yup.string().nullable().required(REQUIRED_MESSAGE),
    requestUser: yup
      .string()
      .nullable()
      .required(REQUIRED_MESSAGE)
      .trim()
      .min(5, "Ingrese mínimo 5 caracteres")
      .max(50, "Ingrese máximo 50 caracteres")
      .matches(/^(([A-Za-zÀ-ÿ])+[ ]?)*$/g, "Ingrese un nombre válido"),
    chargeApplicantId: yup.string().nullable().required(REQUIRED_MESSAGE),
    chargeRequestedId: yup.string().nullable().required(REQUIRED_MESSAGE),
    amount: yup.number().when([], {
      is: () => !cantidadIsDisabled,
      then: yup
        .number("Debe ser un número entre 1 y 20")
        .typeError("Debe ser un número entre 1 y 20")
        .min(1, "Debe ser mayor o igual a 1")
        .max(20, "Debe ser menor o igual a 20")
        .required(REQUIRED_MESSAGE),
      otherwise: yup.number().nullable().notRequired(),
    }),
    replaceUser: yup.string().when([], {
      is: () => !isDisabled,
      then: yup
        .string()
        .required(REQUIRED_MESSAGE)
        .trim()
        .min(5, "Ingrese mínimo 5 caracteres")
        .max(50, "Ingrese máximo 50 caracteres")
        .matches(/^(([A-Za-zÀ-ÿ])+[ ]?)*$/g, "Ingrese un nombre válido"),
      otherwise: yup.string().notRequired(),
    }),
    retirementReason: yup.string().when([], {
      is: () => !isDisabled,
      then: yup.string().nullable().required(REQUIRED_MESSAGE),
      otherwise: yup.string().nullable().notRequired(),
    }),
    requestReason: yup.string().nullable().required(REQUIRED_MESSAGE),
    retirementDate: yup
      .date()
      .nullable()
      .when([], {
        is: () => !isDisabled,
        then: yup
          .date()
          .typeError("Ingrese un formato válido")
          .nullable()
          .min(
            new Date(2019, 11, 31, 23, 59, 29),
            "La menor fecha válida es el 1 de Enero de 2020"
          )
          .required(REQUIRED_MESSAGE),
        otherwise: yup.date().nullable().notRequired(),
      }),
    admissionDate: yup
      .date()
      .nullable()
      .typeError("Ingrese un formato válido")
      .min(
        new Date(2020, 11, 31, 23, 59, 29),
        "La menor fecha válida es el 1 de Enero de 2021"
      )
      .required(REQUIRED_MESSAGE),
    contractType: yup.string().nullable().required(REQUIRED_MESSAGE),
    observations: yup
      .string()
      .nullable()
      .required(REQUIRED_MESSAGE)
      .trim()
      .min(10, "Ingrese mínimo 10 caracteres")
      .max(500, "Ingrese máximo 500 caracteres"),
  });

  const { register, handleSubmit, setValue, control, errors, getValues } =
    useForm({
      resolver: yupResolver(schema),
      defaultValues,
      mode: "onChange",
      reValidateMode: "onChange",
    });

  useEffect(() => {
    if (!isAddMode) {
      const getRequisition = async () => {
        const responseMaestras = await getMaestras();
        const requisitionResponse = await getRequisitionById(id, dispatch);
        const req = requisitionResponse.data;

        setValue("regionalId", req.regional && req.regional.id);
        setValue(
          "requestDate",
          req.requestDate
            ? Utils.convertToDateddMMyyyy(req.requestDate)
            : req.requestDate
        );
        setValue(
          "chargeRequestedId",
          req.chargeRequested && req.chargeRequested.id
        );
        setValue("processId", req.process && req.process.id);
        setValue("requestUser", req.requestUser);
        setValue(
          "chargeApplicantId",
          req.chargeApplicant && req.chargeApplicant.id
        );

        setValue("replaceUser", req.replaceUser);
        setValue("retirementReason", req.retirementReason);
        setValue("requestReason", req.requestReason);
        validateDisabledFieldsCompose(
          "requestReason",
          req.requestReason,
          responseMaestras.data.maestras
        );
        setValue(
          "retirementDate",
          req.retirementDate
            ? Utils.convertToDateddMMyyyy(req.retirementDate)
            : req.retirementDate
        );
        setValue(
          "admissionDate",
          req.admissionDate
            ? Utils.convertToDateddMMyyyy(req.admissionDate)
            : req.admissionDate
        );
        setValue(
          "contractType",
          req.contractType ? req.contractType.toUpperCase() : req.contractType
        );
        setValue("observations", req.observations);
        setValue("amount", req.amount);

        setRequisition(req);
      };
      setTimeout(function () {
        getRequisition();
      }, 500);
    }
  }, []);

  const isDate = (obj) => {
    return typeof obj.getMonth === "function";
  };

  const closeMessage = () => {
    setConfirm((anterior) => ({
      ...anterior,
      open: false,
    }));
  };

  const formatDates = (formData) => {
    const format1 = "DD/MM/YYYY HH:mm:ss";
    formData.requestDate =
      formData.requestDate && isDate(formData.requestDate)
        ? moment(formData.requestDate).format(format1)
        : formData.requestDate;
    formData.retirementDate =
      formData.retirementDate && isDate(formData.retirementDate)
        ? moment(formData.retirementDate).format(format1)
        : formData.retirementDate;
    formData.admissionDate =
      formData.admissionDate && isDate(formData.admissionDate)
        ? moment(formData.admissionDate).format(format1)
        : formData.admissionDate;
    return formData;
  };

  const onSubmit = (data) => {
    setConfirm(() => ({
      open: true,
      question: "¿Está seguro que desea crear el registro? ",
      type: "QUESTION",
      handleClick: () => onSubmitFinalize(data),
      handleClickOut: closeModal,
    }));
  };

  const gotoHome = () => {
    props.history.push("/dashboard/requisicion");
  };

  const onSubmitFinalize = (data) => {
    setIsLoading(true);
    var status = { status: "PENDIENTE_POR_APROBACION" };
    var currentData = Utils.convertStringEmptyToNull(data);
    currentData = formatDates(currentData);
    var newData = { ...currentData, ...status };
    if (!isAddMode) {
      newData = { ...newData, id };
    }
    var defaultDate = {};
    if (isAddMode) {
      defaultDate = { creationDate: currentData.requestDate };
      newData = { ...newData, ...defaultDate };
    } else {
      defaultDate = { creationDate: requisition.creationDate };
      newData = { ...newData, ...defaultDate };
      var requestDate = { requestDate: requisition.requestDate };
      newData = { ...newData, ...requestDate };
      var req = { requisitionNumber: requisition.requisitionNumber };
      newData = { ...newData, ...req };
    }

    closeModal();

    finishRequisition(newData, dispatch).then(
      (response) => {
        setIsLoading(false);
        if (response && response.status === 201) {
          setConfirm(() => ({
            open: true,
            question: "Registro creado exitosamente",
            type: "SUCCESS",
            handleClick: gotoHome,
            oneButtons: true,
            // handleClickOut: closeMessage,
          }));
        } else {
          dispatch({
            type: "OPEN_SNACKBAR",
            openMessage: {
              open: true,
              message: ERROR_MESSAGE,
            },
          });
        }
      },
      (error) => {
        setIsLoading(false);
        dispatch({
          type: "OPEN_SNACKBAR",
          openMessage: {
            open: true,
            message: ERROR_MESSAGE,
          },
        });
      }
    );
  };

  const validateWrongLength = (value, min, max) => {
    return value !== 0 && (value < min || value > max);
  };

  const saveBtnConfirm = () => {
    const currentData = getValues();

    if (validateWrongLength(currentData?.observations?.length, 10, 500)) {
      return;
    }

    if (validateWrongLength(currentData?.requestUser?.length, 5, 50)) {
      return;
    }

    if (validateWrongLength(currentData?.replaceUser?.length, 5, 50)) {
      return;
    }

    if (currentData?.retirementDate?.toString() === "Invalid Date") {
      return;
    } else if (currentData?.retirementDate === undefined) {
      currentData.retirementDate = null;
    } else {
      let minDate = new Date(2019, 11, 31, 23, 59, 29);
      currentData.retirementDate =
        currentData.retirementDate > minDate
          ? currentData.retirementDate
          : moment().toDate();
    }

    if (currentData?.admissionDate?.toString() === "Invalid Date") {
      return;
    } else if (currentData?.admissionDate === undefined) {
      currentData.admissionDate = null;
    } else {
      let minDate = new Date(2020, 11, 31, 23, 59, 29);
      currentData.admissionDate =
        currentData.admissionDate > minDate
          ? currentData.admissionDate
          : moment().toDate();
    }

    let question = isAddMode
      ? "¿Está seguro que desea guardar el registro?"
      : "¿Está seguro que desea editar el registro? ";
    setConfirm(() => ({
      open: true,
      question: question,
      handleClick: () => saveBtn(currentData),
      handleClickOut: closeModal,
      type: "QUESTION",
    }));
  };

  const saveBtn = (currentData) => {
    setIsLoading(true);
    closeModal();
    var status = { status: "EN_ELABORACION" };
    var numberOfValidFields = Utils.getNumberOfValidFields(currentData);
    if (numberOfValidFields < 2) {
      setConfirm({
        open: true,
        question: "Por lo menos debe diligenciar un campo",
        type: "WARNING",
        oneButtons: true,
        // handleClickOut: closeMessage,
        handleClick: closeMessage,
        title: "",
      });

      setIsLoading(false);
      return false;
    }
    currentData = Utils.convertStringEmptyToNull(currentData);

    if (!cantidadIsDisabled && !currentData.amount) {
      setShowAmountMessage(true);
      setIsLoading(false);
      return false;
    } else {
      setShowAmountMessage(false);
    }

    currentData = formatDates(currentData);
    var newData = { ...currentData, ...status };
    if (!isAddMode) {
      newData = { ...newData, id };
    }
    var defaultUser = {};
    var defaultDate = {};
    if (isAddMode) {
      defaultUser = { creationUser: "default user" };
      newData = { ...newData, ...defaultUser };
      defaultDate = { creationDate: currentData.requestDate };
      newData = { ...newData, ...defaultDate };
    } else {
      defaultUser = { creationUser: requisition.creationUser };
      newData = { ...newData, ...defaultUser };
      // defaultDate = { creationDate: requisition.creationDate };
      // newData = { ...newData, ...defaultDate };
      var req = { requisitionNumber: requisition.requisitionNumber };
      newData = { ...newData, ...req };
    }

    saveRequisition(newData, dispatch).then(
      (response) => {
        if (response && response.status >= 200 && response.status < 399) {
          setIsLoading(false);
          let message = isAddMode
            ? "Registro guardado exitosamente"
            : "Registro editado exitosamente";
          setConfirm({
            open: true,
            question: message,
            type: "SUCCESS",
            oneButtons: true,
            // handleClickOut: closeMessage,
            handleClick: gotoHome,
            title: "",
          });
        } else {
          setIsLoading(false);
          dispatch({
            type: "OPEN_SNACKBAR",
            openMessage: {
              open: true,
              message: response?.data ? response?.data?.detail : ERROR_MESSAGE,
            },
          });
        }
        setIsLoading(false);
      },
      (error) => {
        setIsLoading(false);
        dispatch({
          type: "OPEN_SNACKBAR",
          openMessage: {
            open: true,
            message: error ? error?.detail : ERROR_MESSAGE,
          },
        });
      }
    );
  };

  const validateDisabledFieldsCompose = (name, value, maestrasAdd) => {
    let nuevoCargoKey;
    let aumentoDePlantaKey;
    if (maestrasAdd) {
      nuevoCargoKey = maestrasAdd.motivoSolicitud.find(
        (x) => x === NUEVO_CARGO
      );
      aumentoDePlantaKey = maestrasAdd.motivoSolicitud.find(
        (x) => x === AUMENTO_DE_PLANTA
      );
    } else {
      nuevoCargoKey = maestras.motivoSolicitud.find((x) => x === NUEVO_CARGO);
      aumentoDePlantaKey = maestras.motivoSolicitud.find(
        (x) => x === AUMENTO_DE_PLANTA
      );
    }

    if (value === nuevoCargoKey || value === aumentoDePlantaKey) {
      setIsDisabled(true);
      setValue("replaceUser", null);
      setValue("retirementReason", null);
      setValue("retirementDate", null);
    } else {
      setIsDisabled(false);
    }
    if (value === aumentoDePlantaKey) {
      setCantidadIsDisabled(false);
    } else {
      setCantidadIsDisabled(true);
      setValue("amount", 0);
    }
  };

  const validateDisabledFields = (e) => {
    e.preventDefault();
    const { name, value } = e.target;
    validateDisabledFieldsCompose(name, value, null);
  };

  const closeModal = () => {
    setConfirm((anterior) => ({
      ...anterior,
      open: false,
    }));
  };

  const cancelConfirm = () => {
    setConfirm(() => ({
      open: true,
      question: "¿Está seguro que NO desea continuar creando el registro?",
      handleClick: cancel,
      handleClickOut: closeModal,
      type: "QUESTION",
    }));
  };

  const cancel = () => {
    closeModal();
    setConfirm({
      open: true,
      question: "Registro cancelado",
      type: "WARNING",
      oneButtons: true,
      // handleClickOut: closeMessage,
      handleClick: closeMessage,
      title: "",
    });

    setTimeout(() => {
      props.history.goBack();
    }, 3000);
  };

  const openModal = () => setOpen(true);
  // const closeModalVacancies = () => setOpen(false);

  return (
    <React.Fragment>
      <Grid
        container
        spacing={3}
        style={{
          height: "10px",
          marginBottom: "20px",
          marginTop: "20px",
        }}
      ></Grid>
      <ModalConfirmBase
        description={confirm.question}
        open={confirm.open}
        handleClick={confirm.handleClick}
        handleClickOut={confirm.handleClickOut}
        type={confirm.type}
        oneButtons={confirm.oneButtons}
        title={confirm.title}
      />
      <form onSubmit={handleSubmit(onSubmit)} className={classes.form}>
        <Grid container spacing={3}>
          <Grid item xs={12} md={6} lg={3}>
            <FormControl
              variant="outlined"
              fullWidth
              size="small"
              error={
                !!errors.hasOwnProperty("regionalId") &&
                errors["regionalId"].message
              }
            >
              <InputLabel
                htmlFor="outlined-select-regionalId"
                shrink={true}
                size="small"
              >
                Nombre de la regional
              </InputLabel>
              <Controller
                fullWidth
                control={control}
                inputRef={register}
                className={classes.dropdown}
                label="Nombre de la regional"
                size="small"
                name="regionalId"
                notched={true}
                inputProps={{
                  name: "regionalId",
                  id: "outlined-select-regionalId",
                }}
                as={
                  <Select>
                    {regionales.map((op) => (
                      <MenuItem
                        className={classes.menuItem}
                        key={op.id}
                        value={op.id}
                      >
                        <TitleCase string={op.name} />
                      </MenuItem>
                    ))}
                  </Select>
                }
              />
              <FormHelperText>
                {errors.hasOwnProperty("regionalId") &&
                  errors["regionalId"].message}
              </FormHelperText>
            </FormControl>
          </Grid>
          <Grid item xs={12} md={6} lg={3}>
            <MuiPickersUtilsProvider
              locale={deLocale}
              utils={DateFnsUtils}
              className={classes.field}
            >
              <Controller
                as={
                  <KeyboardDatePicker
                    fullWidth
                    inputVariant="outlined"
                    inputProps={{
                      style: {
                        height: "18px",
                        borderRadius: "8px",
                        paddingBottom: "6.5px",
                        fontSize: 14,
                      },
                    }}
                    variant="inline"
                    format="dd/MM/yyyy"
                    disabled="true"
                    dateFormat="DD/MM/YYYY"
                    label="Fecha de solicitud"
                    error={
                      !!errors.hasOwnProperty("requestDate") &&
                      errors["requestDate"].message
                    }
                    helperText={
                      errors.hasOwnProperty("requestDate") &&
                      errors["requestDate"].message
                    }
                  />
                }
                control={control}
                className={classes.dropdown}
                format="dd/MM/yyyy"
                name="requestDate"
                placeholder="Fecha de solicitud"
                size="small"
              />
            </MuiPickersUtilsProvider>
          </Grid>
          <Grid item xs={12} md={6} lg={3}>
            <FormControl
              variant="outlined"
              fullWidth
              size="small"
              error={
                !!errors.hasOwnProperty("chargeRequestedId") &&
                errors["chargeRequestedId"].message
              }
            >
              <InputLabel
                htmlFor="outlined-select-chargeRequestedId"
                shrink={true}
                size="small"
              >
                Cargo solicitado
              </InputLabel>
              <Controller
                fullWidth
                control={control}
                inputRef={register}
                className={classes.dropdown}
                label="Cargo solicitado"
                size="small"
                name="chargeRequestedId"
                notched={true}
                inputProps={{
                  name: "chargeRequestedId",
                  id: "outlined-select-chargeRequestedId",
                }}
                as={
                  <Select>
                    {charges.map((op) => (
                      <MenuItem
                        className={classes.menuItem}
                        key={op.id}
                        value={op.id}
                      >
                        <TitleCase string={op.denomination} />
                      </MenuItem>
                    ))}
                  </Select>
                }
              />

              <FormHelperText>
                {errors.hasOwnProperty("chargeRequestedId") &&
                  errors["chargeRequestedId"].message}
              </FormHelperText>
            </FormControl>
          </Grid>
          <Grid item xs={12} md={6} lg={3}>
            <FormControl
              variant="outlined"
              fullWidth
              size="small"
              error={
                !!errors.hasOwnProperty("processId") &&
                errors["processId"].message
              }
            >
              <InputLabel htmlFor="outlined-select-processId" shrink={true}>
                Proceso
              </InputLabel>
              <Controller
                fullWidth
                control={control}
                size="small"
                className={classes.dropdown}
                inputRef={register}
                label="Proceso"
                name="processId"
                notched={true}
                inputProps={{
                  name: "processId",
                  id: "outlined-select-processId",
                }}
                as={
                  <Select>
                    {process.map((op) => (
                      <MenuItem
                        className={classes.menuItem}
                        key={op.id}
                        value={op.id}
                      >
                        <TitleCase string={op.description} />
                      </MenuItem>
                    ))}
                  </Select>
                }
              />
              <FormHelperText>
                {errors.hasOwnProperty("processId") &&
                  errors["processId"].message}
              </FormHelperText>
            </FormControl>
          </Grid>
          <Grid item xs={12} md={6} lg={3}>
            <FormControl fullWidth className={classes.field}>
              <TextField
                fullWidth
                variant="outlined"
                inputRef={register}
                className={classes.dropdown}
                label="Nombre del Jefe"
                placeholder="Nombre del Jefe"
                name="requestUser"
                size="small"
                InputLabelProps={{ shrink: true }}
                inputProps={{
                  style: {
                    height: "18px",
                    borderRadius: "8px",
                    paddingBottom: "6.5px",
                    fontSize: 14,
                  },
                }}
                error={
                  !!errors.hasOwnProperty("requestUser") &&
                  errors["requestUser"].message
                }
                helperText={
                  errors.hasOwnProperty("requestUser") &&
                  errors["requestUser"].message
                }
              />
            </FormControl>
          </Grid>
          <Grid item xs={12} md={6} lg={3}>
            <FormControl
              variant="outlined"
              fullWidth
              size="small"
              error={
                !!errors.hasOwnProperty("chargeApplicantId") &&
                errors["chargeApplicantId"].message
              }
            >
              <InputLabel
                htmlFor="outlined-select-chargeApplicantId"
                shrink={true}
              >
                Cargo del solicitante
              </InputLabel>
              <Controller
                fullWidth
                control={control}
                inputRef={register}
                className={classes.dropdown}
                label="Cargo del solicitante"
                size="small"
                name="chargeApplicantId"
                notched={true}
                inputProps={{
                  name: "chargeApplicantId",
                  id: "outlined-select-chargeApplicantId",
                }}
                as={
                  <Select>
                    {charges.map((op) => (
                      <MenuItem
                        className={classes.menuItem}
                        key={op.id}
                        value={op.id}
                      >
                        <TitleCase string={op.denomination} />
                      </MenuItem>
                    ))}
                  </Select>
                }
              />

              <FormHelperText>
                {errors.hasOwnProperty("chargeApplicantId") &&
                  errors["chargeApplicantId"].message}
              </FormHelperText>
            </FormControl>
          </Grid>
          <Grid item xs={12} md={6} lg={3}>
            <FormControl
              variant="outlined"
              fullWidth
              size="small"
              error={
                !!errors.hasOwnProperty("requestReason") &&
                errors["requestReason"].message
              }
            >
              <InputLabel htmlFor="outlined-select-requestReason" shrink={true}>
                Motivo de la solicitud
              </InputLabel>
              <Controller
                fullWidth
                control={control}
                inputRef={register}
                size="small"
                name="requestReason"
                render={(props) => (
                  <Select
                    className={classes.dropdown}
                    label="Motivo de la solicitud"
                    notched={true}
                    inputProps={{
                      name: "requestReason",
                      id: "outlined-select-requestReason",
                    }}
                    onChange={(e) => {
                      props.onChange(e);
                      validateDisabledFields(e);
                    }}
                    value={props.value}
                  >
                    {maestras?.motivoSolicitud &&
                      maestras.motivoSolicitud.map((op) => (
                        <MenuItem
                          className={classes.menuItem}
                          key={op}
                          value={op}
                        >
                          <TitleCase string={op} />
                        </MenuItem>
                      ))}
                  </Select>
                )}
              />
              <FormHelperText>
                {errors.hasOwnProperty("requestReason") &&
                  errors["requestReason"].message}
              </FormHelperText>
            </FormControl>
          </Grid>
          {!cantidadIsDisabled && (
            <Grid item xs={12} md={6} lg={3}>
              <FormControl
                variant="outlined"
                fullWidth
                size="small"
                error={
                  (!!errors.hasOwnProperty("amount") &&
                    errors["amount"].message) ||
                  (showAmountMessage && REQUIRED_MESSAGE)
                }
              >
                <InputLabel htmlFor="outlined-select-amount" shrink={true}>
                  Cantidad
                </InputLabel>

                <Controller
                  fullWidth
                  control={control}
                  inputRef={register}
                  size="small"
                  name="amount"
                  render={(props) => (
                    <Select
                      disabled={cantidadIsDisabled}
                      className={classes.dropdown}
                      label="Cantidad"
                      notched={true}
                      inputProps={{
                        name: "amount",
                        id: "outlined-select-amount",
                      }}
                      onChange={(e) => {
                        props.onChange(e);
                      }}
                      value={props.value}
                    >
                      {amountValues.map((op) => (
                        <MenuItem
                          className={classes.menuItem}
                          aria-label="None"
                          value={op}
                        >
                          {op}
                        </MenuItem>
                      ))}
                    </Select>
                  )}
                />
                <FormHelperText>
                  {errors.hasOwnProperty("amount") && errors["amount"].message}
                </FormHelperText>
                <FormHelperText style={{ color: "#f44336" }}>
                  {showAmountMessage && REQUIRED_MESSAGE}
                </FormHelperText>
              </FormControl>
            </Grid>
          )}
          {isDisabled ? null : (
            <Grid item xs={12} md={6} lg={3}>
              <FormControl fullWidth className={classes.field}>
                <TextField
                  fullWidth
                  variant="outlined"
                  inputRef={register}
                  disabled={isDisabled}
                  className={classes.dropdown}
                  label="Persona a reemplazar"
                  placeholder="Persona a reemplazar"
                  name="replaceUser"
                  size="small"
                  InputLabelProps={{ shrink: true }}
                  inputProps={{
                    style: {
                      height: "18px",
                      borderRadius: "8px",
                      paddingBottom: "6.5px",
                      fontSize: 14,
                    },
                  }}
                  error={
                    !isDisabled &&
                    !!errors.hasOwnProperty("replaceUser") &&
                    errors["replaceUser"].message
                  }
                  helperText={
                    !isDisabled &&
                    errors.hasOwnProperty("replaceUser") &&
                    errors["replaceUser"].message
                  }
                />
              </FormControl>
            </Grid>
          )}
          {isDisabled ? null : (
            <Grid item xs={12} md={6} lg={3}>
              <FormControl
                variant="outlined"
                fullWidth
                size="small"
                error={
                  !isDisabled &&
                  !!errors.hasOwnProperty("retirementReason") &&
                  errors["retirementReason"].message
                }
              >
                <InputLabel
                  htmlFor="outlined-select-retirementReason"
                  shrink={true}
                >
                  Motivo del retiro
                </InputLabel>
                <Controller
                  fullWidth
                  control={control}
                  inputRef={register}
                  className={classes.dropdown}
                  label="Motivo del retiro"
                  size="small"
                  disabled={isDisabled}
                  name="retirementReason"
                  notched={true}
                  inputProps={{
                    name: "retirementReason",
                    id: "outlined-select-requestUser",
                  }}
                  as={
                    <Select>
                      {maestras?.motivoRetiro &&
                        maestras.motivoRetiro.map((op) => (
                          <MenuItem
                            className={classes.menuItem}
                            key={op}
                            value={op}
                          >
                            <TitleCase string={op} />
                          </MenuItem>
                        ))}
                    </Select>
                  }
                />
                <FormHelperText>
                  {!isDisabled &&
                    errors.hasOwnProperty("retirementReason") &&
                    errors["retirementReason"].message}
                </FormHelperText>
              </FormControl>
            </Grid>
          )}
          {isDisabled ? null : (
            <Grid item xs={12} md={6} lg={3}>
              <MuiPickersUtilsProvider
                locale={deLocale}
                utils={DateFnsUtils}
                className={classes.field}
              >
                <Controller
                  as={
                    <KeyboardDatePicker
                      fullWidth
                      inputVariant="outlined"
                      variant="inline"
                      format="dd/MM/yyyy"
                      label="Fecha de retiro"
                      InputLabelProps={{ shrink: true }}
                      inputProps={{
                        style: {
                          height: "18px",
                          borderRadius: "8px",
                          paddingBottom: "6.5px",
                          fontSize: 14,
                        },
                      }}
                      error={
                        !isDisabled &&
                        !!errors.hasOwnProperty("retirementDate") &&
                        errors["retirementDate"].message
                      }
                      helperText={
                        !isDisabled &&
                        errors.hasOwnProperty("retirementDate") &&
                        errors["retirementDate"].message
                      }
                      minDate="01.01.2020"
                      disabled={isDisabled}
                    />
                  }
                  control={control}
                  className={classes.dropdown}
                  name="retirementDate"
                  placeholder="Fecha de retiro"
                  size="small"
                />
              </MuiPickersUtilsProvider>
            </Grid>
          )}
          <Grid item xs={12} md={6} lg={3}>
            <MuiPickersUtilsProvider
              locale={deLocale}
              utils={DateFnsUtils}
              className={classes.field}
            >
              <Controller
                as={
                  <KeyboardDatePicker
                    fullWidth
                    inputVariant="outlined"
                    variant="inline"
                    format="dd/MM/yyyy"
                    label="Fecha oportuna de ingreso"
                    minDate="01.01.2021"
                    InputLabelProps={{ shrink: true }}
                    inputProps={{
                      style: {
                        height: "18px",
                        borderRadius: "8px",
                        paddingBottom: "6.5px",
                        fontSize: 14,
                      },
                    }}
                    error={
                      !!errors.hasOwnProperty("admissionDate") &&
                      errors["admissionDate"].message
                    }
                    helperText={
                      errors.hasOwnProperty("admissionDate") &&
                      errors["admissionDate"].message
                    }
                  />
                }
                control={control}
                className={classes.dropdown}
                name="admissionDate"
                placeholder="Fecha oportuna de ingreso"
                size="small"
              />
            </MuiPickersUtilsProvider>
          </Grid>
          <Grid item xs={12} md={6} lg={3}>
            <FormControl
              variant="outlined"
              fullWidth
              size="small"
              error={
                !!errors.hasOwnProperty("contractType") &&
                errors["contractType"].message
              }
            >
              <InputLabel htmlFor="outlined-select-contractType" shrink={true}>
                Tipo de Contrato
              </InputLabel>
              <Controller
                fullWidth
                control={control}
                inputRef={register}
                className={classes.dropdown}
                label="Tipo de contrato"
                size="small"
                name="contractType"
                notched={true}
                inputProps={{
                  name: "contractType",
                  id: "outlined-select-contractType",
                }}
                as={
                  <Select>
                    {statusListContractType === "success" &&
                      data.map((op) => (
                        <MenuItem
                          className={classes.menuItem}
                          key={op.contractTypes}
                          value={op.contractTypes}
                        >
                          <TitleCase string={op.contractTypeDescription} />
                        </MenuItem>
                      ))}
                  </Select>
                }
              />
              <FormHelperText>
                {errors.hasOwnProperty("contractType") &&
                  errors["contractType"].message}
              </FormHelperText>
            </FormControl>
          </Grid>
          <Grid item xs={12} md={6} lg={12}>
            <FormControl fullWidth>
              <TextField
                fullWidth
                variant="outlined"
                inputRef={register}
                className={classes.notes}
                label="Observaciones"
                name="observations"
                placeholder="En este espacio, se deben describir las características especiales del cargo solicitado y/o información adicional"
                multiline
                rows={4}
                rowsMax={4}
                InputLabelProps={{ shrink: true }}
                error={
                  !!errors.hasOwnProperty("observations") &&
                  errors["observations"].message
                }
              />
              <FormHelperText style={{ color: "#f44336" }}>
                {errors.hasOwnProperty("observations") &&
                  errors["observations"].message}
              </FormHelperText>
            </FormControl>
          </Grid>
        </Grid>
        <Grid
          container
          spacing={3}
          justify="flex-end"
          style={{
            marginTop: "15px",
            paddingRight: "12px",
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
            gap: "10px",
          }}
        >
          <BorderRedButton onClick={cancelConfirm}>CANCELAR</BorderRedButton>

          <ColorButton type="submit" disabled={isLoading}>
            FINALIZAR
          </ColorButton>

          {!isAddMode && (
            <BorderGreenButton onClick={saveBtnConfirm} disabled={isLoading}>
              EDITAR
            </BorderGreenButton>
          )}
        </Grid>
      </form>
      <Backdrop style={{ zIndex: "9999" }} open={isLoading}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </React.Fragment>
  );
};

export default withRouter(RequisitionForm);
